export function getTemplateHead(node) {
    return node.head;
}
export function getTemplateSpans(node) {
    return node.templateSpans;
}
export function getLiteral(node) {
    return node.literal;
}
export function getTag(node) {
    return node.tag;
}
export function getTemplate(node) {
    return node.template;
}

//# sourceMappingURL=template.js.map
